import FundDetails from '@/app/modules/fund/components/fund-details/fund-details.vue';
import FundMembers from '@/app/modules/fund/components/fund-members/fund-members.vue';
import FundTrustee from '@/app/modules/fund/components/fund-trustee/fund-trustee.vue';
import FundReview from '@/app/modules/fund/components/fund-review/fund-review.vue';
import { types } from '@/app/filters/filters';
import FundChooseType from '@/app/modules/fund/components/fund-choose-type/fund-choose-type.vue';

const defaultSteps = [
  {
    step: 1,
    name: 'Fund Details',
    component: 'fund-details',
  },
  {
    step: 2,
    name: 'Fund Members',
    component: 'fund-members',
  },
  {
    step: 3,
    name: 'Fund Trustees',
    component: 'fund-trustee',
  },
  {
    step: 4,
    name: 'Fund Review',
    component: 'fund-review',
  },
];

const integrationSteps = [
  {
    step: 1,
    name: 'Fund Search',
    component: 'fund-choose-type',
    disableStepLink: true,
  },
  {
    step: 2,
    name: 'Fund Details',
    component: 'fund-details',
  },
  {
    step: 3,
    name: 'Fund Members',
    component: 'fund-members',
  },
  {
    step: 4,
    name: 'Fund Trustees',
    component: 'fund-trustee',
  },
  {
    step: 5,
    name: 'Fund Review',
    component: 'fund-review',
  },
];

export default {
  name: 'fund-container',
  components: {
    FundDetails,
    FundMembers,
    FundTrustee,
    FundReview,
    FundChooseType,
  },
  data: () => ({
    devMode: process.env.NODE_ENV,
    currentStep: 0,
    stepperData: {
      title: 'Fund Information',
      style: 'blue',
      steps: defaultSteps,
    },
  }),
  methods: {
    handleStepChange(step) {
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.fund.status),
        type: this.$store.getters['toolkit/getItemType'],
        context: 'Fund Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Step',
        uuid: this.fund.uuid,
      });
      this.currentStep = step;
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    async handleBackStep() {
      await this.$store.dispatch('fund/saveFund');
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.fund.status),
        type: this.$store.getters['toolkit/getItemType'],
        context: 'Fund Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Back',
        uuid: this.fund.uuid,
      });
      this.currentStep -= 1;
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    async handleNextStep() {
      await this.$store.dispatch('fund/saveFund');
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.fund.status),
        type: this.$store.getters['toolkit/getItemType'],
        context: 'Fund Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Next',
        uuid: this.fund.uuid,
      });
      this.currentStep += 1;
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
  },
  computed: {
    currentComponent() {
      return this.stepperData.steps[this.currentStep].component;
    },
    fund() {
      return this.$store.getters['fund/getFund'];
    },
  },
  mounted() {
    if (!this.$store.getters['fund/getFundOwner']) {
      this.$store.dispatch('fund/updateOwner');
    }
    if (this.$store.getters['account/hasIntegrationTokens'] && this.$store.getters['account/hasToolkitPro']) {
      this.stepperData.steps = integrationSteps;
    } else {
      this.stepperData.steps = defaultSteps;
    }
    this.$nextTick(() => {
      this.$refs.container.scrollIntoView();
    });
  },
};
